import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import TypeTable from "../../elements/Tables/TypeTable/TypeTable";
import TypeCreationForm from "../../elements/Forms/TypeCreationForm/TypeCreationForm";

import { useFetch } from "../../../Utils/useFetch";

import {
  FETCH_ALL_TYPE_API,
} from "../../../Constants/Apis"
import { Button, Flex, Input, message, Modal } from "antd";
import { reducer } from "../../../Utils/CommonUtils";
import { deleteType } from "../../../Services/TypeService";

const { Search } = Input;

const TypePage = ({ history, userData }) => {
  const initialState = {
    searchKeyword: "",
    filteredInfo: {},
    sorter: {},
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [typeId, setTypeId] = useState(null);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => setIsModalVisible(false);

  const handleDelete = async (id) => {
    setTypeId(id);
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await deleteType(typeId);
      message.success("Type deleted successfully");
      callReFetch();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Something went wrong, failed to delete type."
      );
    }
    setIsModalOpen(false);
  };

  const {
    fetchedData: { data },
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_TYPE_API}`, state);

  const handleSearch = (value) => {
    dispatch({ type: "searchKeyword", payload: value });
    callReFetch();
  };

  return (
    <div
      style={{
        width: "100vw",
        padding: "20px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          width: "50vw",
          maxWidth: "100vw",
        }}
      >
        <Button type="primary" onClick={handleOpenModal}>
          Create New Type
        </Button>
        <Search
          placeholder="Search..."
          allowClear
          onSearch={handleSearch}
          style={{ width: "300px" }}
        />
      </div>

      <TypeTable
        history={history}
        loading={loading}
        data={data}
          userData={userData}
        callReFetch={callReFetch}
        dispatch={dispatch}
        handleDelete={handleDelete}
      />

      <Modal
        title="Create Type"
        open={isModalVisible}
        footer={null}
        onCancel={handleCloseModal}
      >
        <TypeCreationForm
          history={history}
          userData={userData}
          callReFetch={callReFetch}
          onClose={handleCloseModal}
        />
      </Modal>

      <Modal
        title="Delete Type"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
      >
        <p>Are you sure you want to delete this type?</p>
      </Modal>
    </div>
  );
};

TypePage.propTypes = {};

export default TypePage;
